import React from "react";
import {FmlxIcon} from "fmlx-common-ui";
import {FMLX_COMPONENT} from "../../../const/FmlxComponentEnum";

const QuestionPosition = (props) => {
  const {index, changeQuestionPosition} = props;
  let quesNum = "";
  if (index + 1 <= 9) quesNum = `0${index + 1}`;
  else quesNum = `${index + 1}`;
  return (
    <div className="left_buttons">
      <div>{quesNum}</div>
      <div style={{display: "grid", marginLeft: "5.25px"}}>
        <div onClick={() => changeQuestionPosition("up", index)} style={{lineHeight: "0px", margin: "0px"}}>
          <FmlxIcon name={"ArrowUpBox"} size={FMLX_COMPONENT.SIZE.S}/>
        </div>
        <div onClick={() => changeQuestionPosition("down", index)} style={{lineHeight: "0px", margin: "0px"}}>
          <FmlxIcon name={"ArrowDownBox"} size={FMLX_COMPONENT.SIZE.S}/>
        </div>
      </div>
    </div>
  );
};

export default QuestionPosition;
